// extracted by mini-css-extract-plugin
export default {"root":"DashBoardLayout_root__i10bU","wrapper":"DashBoardLayout_wrapper__x5v8F"};